import * as Reflux from "reflux";
export const CartContextActions = {
	onSelectCustomer: Reflux.createAction(["onSelectCustomer"]),
	onOpenOrderEntry: Reflux.createAction(["onOpenOrderEntry"]),
	onCloseOrderEntry: Reflux.createAction(["onCloseOrderEntry"]),
	onOpenSavedCart: Reflux.createAction(["onOpenSavedCart"]),
	onCloseSavedCart: Reflux.createAction(["onCloseSavedCart"]),
	onSelectCardholder: Reflux.createAction(["onSelectCardholder"]),
};
